import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_CORRECTIVE_ACTION } from "../../code-system/observation-corrective-action";

export const OBSERVATION_CORRECTIVE_ACTION_DISPLAY = composeValueSet({
	name: "OBSERVATION_CORRECTIVE_ACTION_DISPLAY",
	description: "Current selection of corrective actions for displaying observations.",
	system: OBSERVATION_CORRECTIVE_ACTION,
	include: getConceptCodes(OBSERVATION_CORRECTIVE_ACTION),
});
